import DoneActivitiesByMonthStackedBarChart from "./DoneActivitiesByMonthStackedBarChart";

export default DoneActivitiesByMonthStackedBarChart;
